import { Message } from "element-ui";
const math = require("mathjs");

const API_SERVER = process.env.VUE_APP_API_SERVER;
const FILE_SERVER = process.env.VUE_APP_FILE_SERVER;
const FILE_LIMI_SIZE = 5; // 5MB

const commonUtils = {
  getApiUrl(apiPath) {
    if (!apiPath) {
      console.error("invalid api path");
      return;
    }
    return API_SERVER + apiPath;
  },
  getImageUrl(imageUri, defaultUrl) {
    if (!defaultUrl) {
      defaultUrl = require("../assets/images/image-not-found.png");
    }
    return imageUri ? FILE_SERVER + imageUri : defaultUrl;
  },
  getFileUrl(fileUri) {
    return fileUri ? FILE_SERVER + fileUri : "";
  },
  checkImageLimitSize(file) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const underLimit = file.size / 1024 / 1024 <= FILE_LIMI_SIZE;
    if (!isJPG && !isPNG) {
      Message.error("上传图片必须是PNG或JPG格式");
      return false;
    }
    if (!underLimit) {
      Message.error("上传图片大小超过限制" + FILE_LIMI_SIZE + "M");
      return false;
    }
    return true;
  },
  undefinedToNull: function (object) {
    var temp = false; //是否存在至少一个数据
    for (var i in object) {
      if (object[i] === undefined) {
        object[i] = ""; //undefined数据转空
      }
      if (object[i]) {
        temp = true;
      }
    }
    return { object, temp };
  },
  maskMobileNo: function (mobileNo) {
    if (!mobileNo) {
      return "";
    }
    return mobileNo.substring(0, 3) + "****" + mobileNo.substring(8);
  },
  formatNumber: function (val) {
    const precision = 14;
    return Number(math.format(val, precision));
  },
};

export { commonUtils };
